import React from 'react';

import './style.scss';

const SwirlIllustrationsExpert: React.FC = () => (
  <>
    <div className="SwirlIllustrations__item SwirlIllustrations__top_left" />
    <div className="SwirlIllustrations__item SwirlIllustrations__top_right" />
    <div className="SwirlIllustrations__item SwirlIllustrations__bottom_left" />
    <div className="SwirlIllustrations__item SwirlIllustrations__bottom_right" />
  </>
);

export default SwirlIllustrationsExpert;
